import React from 'react';
import EditableText from '../editor/EditableText';

const DiscountSection = ({ discountCode }) => {
  return (
    <div className="my-8 md:my-12">
      {/* Outer Gold Gradient Box */}
      <div 
        className="relative overflow-hidden p-8 md:p-12"
        style={{
          background: 'linear-gradient(135deg, #C4A084 0%, #B89968 50%, #A88B5E 100%)',
          boxShadow: '0 10px 40px rgba(168, 139, 94, 0.3)'
        }}
      >
        {/* Decorative white shapes */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-10 -mr-32 -mt-32"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white opacity-10 -ml-24 -mb-24"></div>
        
        <div className="relative z-10 text-center">
          {/* White Text on Gold Background */}
          <EditableText 
            elementId="welcome-title" 
            pageId="home"
            as="h2"
            className="text-2xl md:text-4xl font-bold mb-4 text-white" 
            style={{ fontFamily: 'serif', textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
          >
            Alles, was du suchst, an einem Ort
          </EditableText>
          
          <EditableText 
            elementId="welcome-subtitle" 
            pageId="home"
            as="p"
            className="text-lg md:text-xl mb-8 text-white opacity-95" 
            style={{ textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}
          >
            bequem direkt zu dir nach Hause
          </EditableText>
          
          {/* Inner White Box with Discount */}
          <div 
            className="bg-white px-6 py-8 md:px-10 md:py-12 mx-auto"
            style={{
              maxWidth: '550px',
              background: '#FEFDFB',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)'
            }}
          >
            {/* HYS Logo */}
            <div className="flex justify-center mb-6">
              <div 
                className="w-24 h-24 md:w-28 md:h-28 flex items-center justify-center overflow-hidden"
                style={{
                  background: '#FFFFFF'
                }}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_beb33c1f-3247-43f6-ae36-01b282c7f3e5/artifacts/k6xhbh78_Kopie%20von%20ParfumYoursoul%20%2850%20x%2050%20px%29%20%28300%20x%20350%20px%29%20%28350%20x%20300%20px%29%20%28350%20x%20300%20px%29%20%28350%20x%20300%20px%29%20%28512%20x%20512%20px%29.png"
                  alt="HYS Logo"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            
            {/* Title */}
            <h3 
              className="text-3xl md:text-4xl font-bold text-center mb-4"
              style={{ 
                color: '#B89968',
                letterSpacing: '-0.01em'
              }}
            >
              20% Rabatt für dich!
            </h3>
            
            {/* Subtitle */}
            <p 
              className="text-base md:text-lg text-center mb-6"
              style={{ color: '#8B7355' }}
            >
              Dein persönlicher Code:
            </p>
            
            {/* Code Box - Full Width */}
            <div className="mb-5">
              <div 
                className="py-3 md:py-4"
                style={{
                  background: '#B4DDD0'
                }}
              >
                <code 
                  className="text-xl md:text-2xl font-bold block text-center"
                  style={{ 
                    color: '#FFFFFF',
                    letterSpacing: '0.2em'
                  }}
                >
                  {discountCode || 'WELCOME20'}
                </code>
              </div>
            </div>
            
            {/* Bottom Text with Star */}
            <div className="flex items-center justify-center gap-2">
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 20 20" 
                fill="#D4AF37" 
                className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0"
              >
                <path fillRule="evenodd" d="M10.868 2.884c-.321-.772-1.415-.772-1.736 0l-1.83 4.401-4.753.381c-.833.067-1.171 1.107-.536 1.651l3.62 3.102-1.106 4.637c-.194.813.691 1.456 1.405 1.02L10 15.591l4.069 2.485c.713.436 1.598-.207 1.404-1.02l-1.106-4.637 3.62-3.102c.635-.544.297-1.584-.536-1.65l-4.752-.382-1.831-4.401z" clipRule="evenodd" />
              </svg>
              <span 
                className="text-xs md:text-sm font-medium"
                style={{ color: '#8B7355' }}
              >
                Code beim Checkout eingeben & sparen!
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountSection;
